import { ProductSuggestionsSearchParams } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getProductSuggestions } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';

export function productSuggestionOptions(
  access_token: string,
  id: string,
  params: ProductSuggestionsSearchParams
) {
  return queryOptions({
    queryKey: ['ProductSuggestions', id, params],
    queryFn: () => getProductSuggestions(access_token, id, params),
    staleTime: 1000 * 60 * 5,
    enabled: !!id,
  });
}

export const useProductSuggestions = (
  id: string,
  params: Omit<ProductSuggestionsSearchParams, 'warehouse'>
) => {
  const { access_token: token } = useAuthStore();
  const { selectedShipToId } = useShipToStore();
  return useQuery(
    productSuggestionOptions(token, id, {
      warehouse: selectedShipToId,
      ...params,
    })
  );
};
